const join = (...args: string[]): string => args.join(' ')
export default join
